/* eslint-disable */
import * as Types from '../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import { ProductSearchItem__ProductSearchResultFragmentDoc } from '../products/Product.generated.js';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateItemAutoCompleteTemplatesQueryVariables = Types.Exact<{
  searchTerm?: Types.InputMaybe<Types.Scalars['String']['input']>;
  applicableFor?: Types.InputMaybe<Array<Types.TplApplicableFor>>;
  excludeTemplateId: Types.Scalars['ID']['input'];
}>;


export type CreateItemAutoCompleteTemplatesQuery = { quoteTemplates: { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } | { __typename: 'QuoteTemplateConnection', edges: Array<{ __typename: 'QuoteTemplateEdge', node: { __typename: 'QuoteTemplate', id: string, resolvedAsReadModelVersionNumber?: number | null, title: string } }> } };

export type CreateItemAutoCompleteProductsQueryVariables = Types.Exact<{
  searchTerm?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type CreateItemAutoCompleteProductsQuery = { pimSearchProducts: { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } | { __typename: 'PimSearchProductConnection', edges: Array<{ __typename: 'PimSearchProductsEdge', node: { __typename: 'PimCustomSupplierProductSearchResult', id: string, supplierId: string, gtin?: string | null, articleNumber: string, organisationFavourite: boolean, brand?: string | null, manufacturerArticleNumber?: string | null, texts?: { __typename: 'PimProductTexts', title?: string | null, description?: string | null, extendedDescription?: string | null } | null, supplier: { __typename: 'PimSupplier', id: string, title: string, logo?: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } | null }, pricing?: { __typename: 'PimPricing', listPrice?: number | null, purchasePrice?: number | null, netPrice?: number | null } | null, attachments: Array<{ __typename: 'ProductAttachmentSnapshot', id: number, title: string, mimeType: string, url: string, group: string }>, status?: { __typename: 'PimSupplierProductStatus', value: Types.PimSupplierProductStatusValue, validFrom: any, validTo?: any | null } | null, productType?: { __typename: 'PimProductTypeMinimal', id: string, key: string, title: string, productTypeSystemKey: string } | null, preferences: Array<{ __typename: 'PimProductPreferenceAttribution', scope: Types.PimProductPreferenceScope, productType: { __typename: 'PimProductPreferenceProductType', productTypeSystemKey: string, productTypeKey: string } }> } | { __typename: 'PimSupplierProductSearchResult', id: string, supplierId: string, gtin?: string | null, articleNumber: string, organisationFavourite: boolean, supplierFavourite: boolean, brand?: string | null, manufacturerArticleNumber?: string | null, texts?: { __typename: 'PimProductTexts', title?: string | null, description?: string | null, extendedDescription?: string | null } | null, supplier: { __typename: 'PimSupplier', id: string, title: string, logo?: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } | null }, pricing?: { __typename: 'PimPricing', listPrice?: number | null, purchasePrice?: number | null, netPrice?: number | null } | null, attachments: Array<{ __typename: 'ProductAttachmentSnapshot', id: number, title: string, mimeType: string, url: string, group: string }>, status?: { __typename: 'PimSupplierProductStatus', value: Types.PimSupplierProductStatusValue, validFrom: any, validTo?: any | null } | null, productType?: { __typename: 'PimProductTypeMinimal', id: string, key: string, title: string, productTypeSystemKey: string } | null, preferences: Array<{ __typename: 'PimProductPreferenceAttribution', scope: Types.PimProductPreferenceScope, productType: { __typename: 'PimProductPreferenceProductType', productTypeSystemKey: string, productTypeKey: string } }> } }> } };

export type CreateItemAutoCompleteProductListsQueryVariables = Types.Exact<{
  searchTerm?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type CreateItemAutoCompleteProductListsQuery = { productLists: { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } | { __typename: 'ProductListConnection', totalCount: number, edges: Array<{ __typename: 'ProductListEdge', node: { __typename: 'ProductList', id: string, title: string, itemCount: number } }> } };

export type CreateItemRecommendationsQueryVariables = Types.Exact<{
  projectId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
  docId: Types.Scalars['ID']['input'];
  itemId: Types.Scalars['ID']['input'];
}>;


export type CreateItemRecommendationsQuery = { item: { __typename: 'Item', id: string, recommendations: Array<{ __typename: 'ItemRecommendation', id: string, teaserTitle: string, rank: number, recommendedEntity: { __typename: 'RecommendedTemplate', templateId: string, templateVersionNumber: number } | { __typename: 'RecommendedTemplateType', templateTypeId: string } }> } | { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } };


export const CreateItemAutoCompleteTemplatesDocument = gql`
    query CreateItemAutoCompleteTemplates($searchTerm: String, $applicableFor: [TplApplicableFor!], $excludeTemplateId: ID!) {
  quoteTemplates(
    limit: 5
    search: $searchTerm
    filters: {sources: [available], applicableFor: $applicableFor, excludeTemplateIds: [$excludeTemplateId]}
    sorting: {column: title, direction: asc}
  ) {
    ... on QuoteTemplateConnection {
      edges {
        node {
          id
          resolvedAsReadModelVersionNumber
          title
        }
      }
    }
  }
}
    `;

/**
 * __useCreateItemAutoCompleteTemplatesQuery__
 *
 * To run a query within a React component, call `useCreateItemAutoCompleteTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreateItemAutoCompleteTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreateItemAutoCompleteTemplatesQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *      applicableFor: // value for 'applicableFor'
 *      excludeTemplateId: // value for 'excludeTemplateId'
 *   },
 * });
 */
export function useCreateItemAutoCompleteTemplatesQuery(baseOptions: Apollo.QueryHookOptions<CreateItemAutoCompleteTemplatesQuery, CreateItemAutoCompleteTemplatesQueryVariables> & ({ variables: CreateItemAutoCompleteTemplatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CreateItemAutoCompleteTemplatesQuery, CreateItemAutoCompleteTemplatesQueryVariables>(CreateItemAutoCompleteTemplatesDocument, options);
      }
export function useCreateItemAutoCompleteTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CreateItemAutoCompleteTemplatesQuery, CreateItemAutoCompleteTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CreateItemAutoCompleteTemplatesQuery, CreateItemAutoCompleteTemplatesQueryVariables>(CreateItemAutoCompleteTemplatesDocument, options);
        }
export function useCreateItemAutoCompleteTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CreateItemAutoCompleteTemplatesQuery, CreateItemAutoCompleteTemplatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CreateItemAutoCompleteTemplatesQuery, CreateItemAutoCompleteTemplatesQueryVariables>(CreateItemAutoCompleteTemplatesDocument, options);
        }
export type CreateItemAutoCompleteTemplatesQueryHookResult = ReturnType<typeof useCreateItemAutoCompleteTemplatesQuery>;
export type CreateItemAutoCompleteTemplatesLazyQueryHookResult = ReturnType<typeof useCreateItemAutoCompleteTemplatesLazyQuery>;
export type CreateItemAutoCompleteTemplatesSuspenseQueryHookResult = ReturnType<typeof useCreateItemAutoCompleteTemplatesSuspenseQuery>;
export type CreateItemAutoCompleteTemplatesQueryResult = Apollo.QueryResult<CreateItemAutoCompleteTemplatesQuery, CreateItemAutoCompleteTemplatesQueryVariables>;
export const CreateItemAutoCompleteProductsDocument = gql`
    query CreateItemAutoCompleteProducts($searchTerm: String) {
  pimSearchProducts(offset: 0, limit: 5, search: $searchTerm) {
    ... on PimSearchProductConnection {
      edges {
        node {
          id
          ...ProductSearchItem__ProductSearchResult
        }
      }
    }
  }
}
    ${ProductSearchItem__ProductSearchResultFragmentDoc}`;

/**
 * __useCreateItemAutoCompleteProductsQuery__
 *
 * To run a query within a React component, call `useCreateItemAutoCompleteProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreateItemAutoCompleteProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreateItemAutoCompleteProductsQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *   },
 * });
 */
export function useCreateItemAutoCompleteProductsQuery(baseOptions?: Apollo.QueryHookOptions<CreateItemAutoCompleteProductsQuery, CreateItemAutoCompleteProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CreateItemAutoCompleteProductsQuery, CreateItemAutoCompleteProductsQueryVariables>(CreateItemAutoCompleteProductsDocument, options);
      }
export function useCreateItemAutoCompleteProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CreateItemAutoCompleteProductsQuery, CreateItemAutoCompleteProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CreateItemAutoCompleteProductsQuery, CreateItemAutoCompleteProductsQueryVariables>(CreateItemAutoCompleteProductsDocument, options);
        }
export function useCreateItemAutoCompleteProductsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CreateItemAutoCompleteProductsQuery, CreateItemAutoCompleteProductsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CreateItemAutoCompleteProductsQuery, CreateItemAutoCompleteProductsQueryVariables>(CreateItemAutoCompleteProductsDocument, options);
        }
export type CreateItemAutoCompleteProductsQueryHookResult = ReturnType<typeof useCreateItemAutoCompleteProductsQuery>;
export type CreateItemAutoCompleteProductsLazyQueryHookResult = ReturnType<typeof useCreateItemAutoCompleteProductsLazyQuery>;
export type CreateItemAutoCompleteProductsSuspenseQueryHookResult = ReturnType<typeof useCreateItemAutoCompleteProductsSuspenseQuery>;
export type CreateItemAutoCompleteProductsQueryResult = Apollo.QueryResult<CreateItemAutoCompleteProductsQuery, CreateItemAutoCompleteProductsQueryVariables>;
export const CreateItemAutoCompleteProductListsDocument = gql`
    query CreateItemAutoCompleteProductLists($searchTerm: String) {
  productLists(
    offset: 0
    limit: 5
    search: $searchTerm
    sorting: [{column: createdAt, direction: desc}]
  ) {
    ... on ProductListConnection {
      edges {
        node {
          id
          title
          itemCount
        }
      }
      totalCount
    }
  }
}
    `;

/**
 * __useCreateItemAutoCompleteProductListsQuery__
 *
 * To run a query within a React component, call `useCreateItemAutoCompleteProductListsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreateItemAutoCompleteProductListsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreateItemAutoCompleteProductListsQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *   },
 * });
 */
export function useCreateItemAutoCompleteProductListsQuery(baseOptions?: Apollo.QueryHookOptions<CreateItemAutoCompleteProductListsQuery, CreateItemAutoCompleteProductListsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CreateItemAutoCompleteProductListsQuery, CreateItemAutoCompleteProductListsQueryVariables>(CreateItemAutoCompleteProductListsDocument, options);
      }
export function useCreateItemAutoCompleteProductListsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CreateItemAutoCompleteProductListsQuery, CreateItemAutoCompleteProductListsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CreateItemAutoCompleteProductListsQuery, CreateItemAutoCompleteProductListsQueryVariables>(CreateItemAutoCompleteProductListsDocument, options);
        }
export function useCreateItemAutoCompleteProductListsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CreateItemAutoCompleteProductListsQuery, CreateItemAutoCompleteProductListsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CreateItemAutoCompleteProductListsQuery, CreateItemAutoCompleteProductListsQueryVariables>(CreateItemAutoCompleteProductListsDocument, options);
        }
export type CreateItemAutoCompleteProductListsQueryHookResult = ReturnType<typeof useCreateItemAutoCompleteProductListsQuery>;
export type CreateItemAutoCompleteProductListsLazyQueryHookResult = ReturnType<typeof useCreateItemAutoCompleteProductListsLazyQuery>;
export type CreateItemAutoCompleteProductListsSuspenseQueryHookResult = ReturnType<typeof useCreateItemAutoCompleteProductListsSuspenseQuery>;
export type CreateItemAutoCompleteProductListsQueryResult = Apollo.QueryResult<CreateItemAutoCompleteProductListsQuery, CreateItemAutoCompleteProductListsQueryVariables>;
export const CreateItemRecommendationsDocument = gql`
    query CreateItemRecommendations($projectId: ID, $docId: ID!, $itemId: ID!) {
  item(projectId: $projectId, docId: $docId, itemId: $itemId) {
    ... on Item {
      id
      recommendations {
        id
        teaserTitle
        rank
        recommendedEntity {
          ... on RecommendedTemplate {
            templateId
            templateVersionNumber
          }
          ... on RecommendedTemplateType {
            templateTypeId
          }
        }
      }
    }
  }
}
    `;

/**
 * __useCreateItemRecommendationsQuery__
 *
 * To run a query within a React component, call `useCreateItemRecommendationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreateItemRecommendationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreateItemRecommendationsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      docId: // value for 'docId'
 *      itemId: // value for 'itemId'
 *   },
 * });
 */
export function useCreateItemRecommendationsQuery(baseOptions: Apollo.QueryHookOptions<CreateItemRecommendationsQuery, CreateItemRecommendationsQueryVariables> & ({ variables: CreateItemRecommendationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CreateItemRecommendationsQuery, CreateItemRecommendationsQueryVariables>(CreateItemRecommendationsDocument, options);
      }
export function useCreateItemRecommendationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CreateItemRecommendationsQuery, CreateItemRecommendationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CreateItemRecommendationsQuery, CreateItemRecommendationsQueryVariables>(CreateItemRecommendationsDocument, options);
        }
export function useCreateItemRecommendationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CreateItemRecommendationsQuery, CreateItemRecommendationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CreateItemRecommendationsQuery, CreateItemRecommendationsQueryVariables>(CreateItemRecommendationsDocument, options);
        }
export type CreateItemRecommendationsQueryHookResult = ReturnType<typeof useCreateItemRecommendationsQuery>;
export type CreateItemRecommendationsLazyQueryHookResult = ReturnType<typeof useCreateItemRecommendationsLazyQuery>;
export type CreateItemRecommendationsSuspenseQueryHookResult = ReturnType<typeof useCreateItemRecommendationsSuspenseQuery>;
export type CreateItemRecommendationsQueryResult = Apollo.QueryResult<CreateItemRecommendationsQuery, CreateItemRecommendationsQueryVariables>;